import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT_ACCOUNT } from '@visiativ/digital-account-front';

/**
 * Interceptor qui ajoute withCredentials: true uniquement aux requêtes vers la gateway
 * pour permettre l'envoi des cookies de session au backend (BFF pattern)
 *
 * Les requêtes vers des services externes (comme Azure B2C) ne sont pas affectées
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
	const environment = inject(ENVIRONMENT_ACCOUNT);

	// N'ajouter withCredentials que pour les requêtes vers notre gateway
	if (req.url.startsWith(environment.gatewayUrl)) {
		const clonedRequest = req.clone({
			withCredentials: true,
		});
		return next(clonedRequest);
	}

	// Pour toutes les autres requêtes, laisser passer sans modification
	return next(req);
};
